/* eslint-disable no-shadow */
enum ValueOrigin {
  CONSTANT = 'Constant',
  LOCAL = 'Local',
  GLOBAL = 'Global'
}

export default ValueOrigin;
